"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var convertPixelToEm = function convertPixelToEm(pixelValue) {
  return pixelValue / 16;
};

var _default = convertPixelToEm;
exports["default"] = _default;